export default __webpack_public_path__ + "static/gugpung2-f0b8c20676d7d1d7fb4c9d7a05ec43e1.png";